import { ColumnViewModel } from '../../shared/column-types';

export const CHEMICALS_VDA_EVIDENCE: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'variantStrID',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiIDs',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'gof_lof',
    'associationType',
    'ancestry_name',
    'disease_model',
    'sex',
    'gender',
    'sentenceHTML',
    'text',
    'chemsInSentence',
    'chemIDs',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'source',
    'variantDSI',
    'variantDPI',
    'pValue',
    'chromosome',
    'coord',
    'alleleFreqExome',
    'alleleFreqGenome',
    'riskAllele',
    'DBSNPclass',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'chemical_effect',
    'clinical_significance',
    'association',
    'citation_count',
    'icite_apt',
  ],
  defaultVisible: [
    'geneSymbol',
    'variantStrID',
    'diseaseName',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'disease_model',
    'sex',
    'gender',
    'sentenceHTML',
    'chemsInSentence',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'riskAllele',
  ],
};